import React from "react";
import { Box, Grid, Typography as MuiTypography } from "@material-ui/core";
import styled from "styled-components/macro";
import Chips from "../../../../components/Chips";
import { spacing } from "@material-ui/system";
import Button from "@material-ui/core/Button";
import { MultiSelect } from "@lrewater/lre-react";

const ChipsGroup = styled.div`
  ${spacing};
  margin-top: ${({ theme }) => theme.spacing(2)}px;
  margin-left: 3px;
  margin-right: 3px;
`;

const FilterGroup = styled(Box)`
  width: 100%;
  :not(:last-child) {
    border-bottom: 1px solid #dddddd;
  }
`;

const Typography = styled(MuiTypography)(spacing);

const ParametersControl = ({
  props: {
    filterValues,
    handleFilterValues,
    parameterGroups,
    threats,
    parameters,
    onSelectAllParameters,
    onSelectNoneParameters,
  },
}) => {
  return (
    <div>
      <FilterGroup p={1}>
        <Typography color="secondary" variant="subtitle1" gutterBottom>
          Filter Groups
        </Typography>
        <ChipsGroup mb={4}>
          <MultiSelect
            data={parameterGroups}
            valueField="parameter_group_name"
            displayField="parameter_group_name"
            onChange={(e) => {
              if (e.target.value.includes("all/none")) {
                return null;
              } else {
                handleFilterValues("parameterGroups", e.target);
              }
            }}
            value={filterValues.parameterGroups}
            name="parameterGroups"
            label="Parameter Groups"
            variant="outlined"
            outlineColor="primary"
            labelColor="primary"
            margin="normal"
            style={{ width: "264px" }}
          />
        </ChipsGroup>
        <ChipsGroup mb={4}>
          <MultiSelect
            data={threats}
            valueField="threat_desc"
            displayField="threat_desc"
            onChange={(e) => {
              if (e.target.value.includes("all/none")) {
                return null;
              } else {
                handleFilterValues("threats", e.target);
              }
            }}
            value={filterValues.threats}
            name="threats"
            label="Focus Areas"
            variant="outlined"
            outlineColor="primary"
            labelColor="primary"
            margin="normal"
            style={{ width: "264px" }}
          />
        </ChipsGroup>
      </FilterGroup>

      <FilterGroup p={1}>
        <ChipsGroup mb={2}>
          <Typography color="secondary" variant="subtitle1" gutterBottom>
            Parameters
          </Typography>
          <Box mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  disabled={!parameters.length}
                  variant="outlined"
                  color="primary"
                  fullWidth
                  size="small"
                  onClick={onSelectAllParameters}
                >
                  + Select All
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  disabled={!parameters.length}
                  variant="outlined"
                  color="primary"
                  fullWidth
                  size="small"
                  onClick={onSelectNoneParameters}
                >
                  - Select None
                </Button>
              </Grid>
            </Grid>
          </Box>
          {parameters.length === 0 && (
            <Typography mt={3} align="center" variant="subtitle2">
              ----- None Available -----
            </Typography>
          )}
          <Chips
            data={parameters}
            valueField="parameter_abbrev"
            displayField="parameter_abbrev"
            handleChipClick={(e) =>
              handleFilterValues("parameters", e.target.textContent)
            }
            type="parameter-type"
            activeChips={filterValues.parameters}
            tooltipField1="parameter_name"
            tooltipField2="unit_desc"
          />
        </ChipsGroup>
      </FilterGroup>
    </div>
  );
};

export default ParametersControl;
